import {create} from 'jss';
import {jssPreset, StylesProvider} from '@material-ui/styles';
import ReactDOM from 'react-dom';
import React from 'react';
import {StyleSheetManager} from "styled-components";
import {BaseAppProviderProps} from "../types";
import {ComponentWrapper} from "../component-wrapper/component-wrapper";

/**
 * Web component wrapper that wrap the react component into a shadow dom web component
 * shadow dom is used to isolate your custom component from element styles
 */

export function WebComponentWrapper(
  NAME: string,
  Component: (args: any) => JSX.Element,
  AppProvider: (args: BaseAppProviderProps) => JSX.Element
): void {

  class WebComponent extends HTMLElement {
    props = {};

    connectedCallback() {
      const shadowRoot = super.attachShadow({mode: 'open'});
      const mountPoint = document.createElement('span');
      const styleContainer = document.createElement("div")
      const appContainer = document.createElement("div")
      const hostStyle = document.createElement("style")
      hostStyle.textContent = `
                            :host {
                              display: block;
                            }`
      shadowRoot.appendChild(styleContainer)
      shadowRoot.appendChild(appContainer)
      shadowRoot.appendChild(hostStyle)
      mountPoint.id = NAME;
      const reactRoot = shadowRoot.appendChild(mountPoint);
      const jss = create({
        ...jssPreset(),
        insertionPoint: reactRoot,
      });

      if ((Component as any).propTypes) {
        this.props = Object.keys((Component as any).propTypes)
          // pass login mode to all components
          .concat(['loginMode']).reduce(
            (obj, item) => {
              return {
                ...obj,
                [`${item}`]: super.getAttribute(item),
              };
            },
            {}
          );
      }

      ReactDOM.render(
        <React.StrictMode>
          <StylesProvider jss={jss} sheetsManager={new Map()}>
            <StyleSheetManager target={styleContainer}>
              <ComponentWrapper {...this.props} appProvider={AppProvider}>
                <Component {...this.props} />
              </ComponentWrapper>
            </StyleSheetManager>
          </StylesProvider>
        </React.StrictMode>,
        mountPoint
      );


    }
  }

  if (!customElements.get(NAME)) {
    customElements.define(NAME, WebComponent as any);
  }
}
